import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/find';
import 'rxjs/add/operator/map';


import { environment } from './../../environments/environment';
import { Configurations } from "../core/configurations";
import { DizionarioModel } from './../models/shared/dizionario.model';
import { PartiteSearchModel } from "../models/incassi/partite-search.model";
import { ClienteListItemModel } from "../models/clienti/cliente-list-item.model";
import { PartitaListItemModel ,SituazionePartiteClienteList} from '../models/incassi/partita-list-item.model';

import { LocalDb } from "../core/localdb";
import {AuthService} from "./auth.service";
import { ClienteModel } from "../models/clienti/cliente.model";
import { NotificationModel } from "../models/shared/notificationModel.model";


@Injectable()
export class PartiteService {
  APIPartite = this.configuration.apiBaseUrlPartite;
  MethodLista = "listaPartite";
  MethodListaAssociate = "listaPartiteAssegnate";
  MethodSituazionePartite = "situazionePartiteClienti";
  result: ClienteListItemModel[];
  constructor(private http: Http, private configuration: Configurations,private authenticationService:AuthService) {
  }

  getList(model: PartiteSearchModel): Observable<PartitaListItemModel[]> {
    let searchParams = model || new PartiteSearchModel();
    return this.http.post(this.APIPartite + this.MethodLista, searchParams)
      .map((r: Response) => r.json() as PartitaListItemModel[]);

  }
  getListaPartiteAssegnate(token: string): Observable<PartitaListItemModel[]> {
    return this.http.get(this.APIPartite + this.MethodListaAssociate + "/" + token)
      .map((r: Response) => r.json() as PartitaListItemModel[]).catch((r: Response, o) => {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
        
        return Observable.throw(r);
      });

  }


  save(model: PartitaListItemModel[], tokenI: string): Observable<NotificationModel> {
    return this.http.post(this.APIPartite + tokenI, model)
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error));

  }

  SituazioniPartiteClienti(model: ClienteListItemModel[]): Observable<SituazionePartiteClienteList[]> {
    console.log("richiesta situazione partite:"+ JSON.stringify(model));
    let lista = model.map(o => {
      return o.codiceClienteAS400;
    });
    return this.http.post(this.APIPartite + this.MethodSituazionePartite, { codiciClientiAs400: lista })
      .map(res => {
        return res.json() as SituazionePartiteClienteList[]; })
      .catch((error: any) => Observable.throw(error));
  } 

}


/*
const STATI_PARTITE: DizionarioModel[] = [
  { id: 1, descrizione: 'Da saldare' },
  { id: 3, descrizione: 'Saldate' }
];*/




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/partite.service.ts